import { postReqAuth } from '../../api';

export const createTeacher = (data, cb) =>
  postReqAuth('/webapi/institute/teacher/create', data, '', cb);

export const getAllTeachersAdmin = (cb) =>
  postReqAuth('/webapi/institute/teacher/get/all', {}, '', cb);

export const getSingleTeacherAdmin = (teacherId, cb) =>
  postReqAuth('/webapi/institute/teacher/get/single', { teacherId }, '', cb);

export const deleteTeacherAdmin = (teacherId, cb) =>
  postReqAuth('/webapi/institute/teacher/delete', { teacherId }, '', cb);

export const getTeachersByCourseAdmin = (courseId, cb) =>
  postReqAuth('/webapi/institute/teacher/get/by-course', { courseId }, '', cb);
